import { render, staticRenderFns } from "./scramble_wrestler_edit.vue?vue&type=template&id=dafdba70&"
import script from "./scramble_wrestler_edit.vue?vue&type=script&lang=js&"
export * from "./scramble_wrestler_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports